import {
  Box,
  Button,
  Card,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Container } from '@mui/system';
import ModalsWrapper from 'src/components/Modals/ModalsWrapper';
import { TableLoader, TableNotFound } from 'src/Utils/TableLoader';
import VisibilityIcon from '@mui/icons-material/Delete';
import EditIcons from '@mui/icons-material/Edit';
import DeleteDataApi from 'src/common/FetchData/DeleteDataApi';
import GetDataApi from 'src/common/FetchData/GetDataApi';
import PopoverComponent from 'src/common/PopoverComponent';
import CreateSMS from './CreateSMS';
import EditSMS from './EditSMS';

type ISMSList = {
  id: number;
  text: string;
  type: string;
  status: number;
  created_by: number;
  created_at: string;
  update_at: string;
};
const SMSList = () => {
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editId, setEditId] = useState<number | string>('');
  const [filter, setFilter] = useState<{
    page: string | number;
    limit: string | number;
  }>({
    page: 1,
    limit: 30,
  });
  const { response, loading, getData, total } = GetDataApi<ISMSList[]>(
    `/api/admin/member-sms?limit=${filter.limit}&page=${filter.page}`,
    true
  );

  const { deleteData, success, setSuccess } = DeleteDataApi(
    `/api/admin/member-sms`
  );

  useEffect(() => {
    getData();
  }, [filter]);
  useEffect(() => {
    if (success) {
      getData();
      setSuccess(false);
    }
  }, [success]);
  return (
    <Box>
      <Container sx={{ mt: 4 }} maxWidth='xl'>
        <Grid
          container
          direction='row'
          justifyContent='center'
          alignItems='stretch'
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              <CardHeader
                action={
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: 2,
                    }}
                  >
                    <Button
                      onClick={() => setOpen(true)}
                      variant='contained'
                      size='small'
                    >
                      Create SMS
                    </Button>
                  </Box>
                }
                title='SMS List'
              />
              <Divider />
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>SL.</TableCell>
                      <TableCell>SMS Text</TableCell>
                      <TableCell>SMS Type</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <TableLoader />
                    ) : response?.length ? (
                      <>
                        {response?.map((e, index) => (
                          <TableRow key={e?.id}>
                            <TableCell
                              sx={{ maxWidth: '600px', textAlign: 'justify' }}
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell
                              sx={{ maxWidth: '600px', textAlign: 'justify' }}
                            >
                              {e.text}
                            </TableCell>
                            <TableCell>
                              <Box>{e.type}</Box>{' '}
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: 'flex',
                                  width: '60px',
                                  alignContent: 'center',
                                }}
                              >
                                <Box
                                  sx={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    setOpenEdit(true);
                                    setEditId(e.id);
                                  }}
                                >
                                  <IconButton
                                    sx={{
                                      color: 'green',
                                    }}
                                    color='inherit'
                                    size='small'
                                  >
                                    <EditIcons sx={{ fontSize: '20px' }} />
                                  </IconButton>
                                </Box>
                                <PopoverComponent
                                  popOverTitle='Are you sure to delete this?'
                                  handleConfirm={() => deleteData(e.id)}
                                >
                                  <IconButton
                                    sx={{
                                      color: 'red',
                                    }}
                                    color='inherit'
                                    size='small'
                                    disabled={loading}
                                  >
                                    <VisibilityIcon sx={{ fontSize: '20px' }} />
                                  </IconButton>
                                </PopoverComponent>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </>
                    ) : (
                      <TableNotFound />
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box p={2}>
                <TablePagination
                  component='div'
                  count={total as number}
                  onPageChange={(_event: any, newPage: number) =>
                    setFilter({ ...filter, page: newPage })
                  }
                  onRowsPerPageChange={(event) =>
                    setFilter({ ...filter, limit: event.target.value })
                  }
                  page={Number(filter.page) && Number(filter.page)}
                  rowsPerPage={Number(filter.limit)}
                  rowsPerPageOptions={[30, 50, 75, 100]}
                />
              </Box>
              <ModalsWrapper
                setShowModal={setOpen}
                showModal={open}
                modalData={{ title: 'Create SMS' }}
                maxWidth='sm'
              >
                <CreateSMS
                  handleClose={() => {
                    setOpen(false);
                    getData();
                  }}
                />
              </ModalsWrapper>

              <ModalsWrapper
                setShowModal={setOpenEdit}
                showModal={openEdit}
                modalData={{ title: 'Update SMS' }}
                maxWidth='sm'
              >
                <EditSMS
                  handleClose={() => {
                    setOpenEdit(false);
                    getData();
                  }}
                  id={editId}
                />
              </ModalsWrapper>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default SMSList;
